
import wixWindow from 'wix-window';
$w.onReady(function () {
  let myLang = wixWindow.multilingual.currentLanguage; 
  if (myLang === 'en') {
    $w('#horizontalMenu1').hide();
    $w('#languageSelector17').show();
    $w('#horizontalMenu2').show();
    $w('#image45').show();
  } else {
    $w('#horizontalMenu2').hide();
    $w('#horizontalMenu1').show();
    $w('#image10').show();
    $w('#languageSelector19').show();
  }
});